import {
  CardBody,
  Col,
  Card,
  CardHeader,
  Row,
  Table,
  Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { getClientDetail } from "connection/backend";
import Loader from "../../../components/Common/Loader";
import PaymentModal from "pages/Dashboard/Tickets/Modal2";
import SummaryModal from "./Modal1";

const ClientCard = (props) => {
  const [render, setRender] = useState(false);
  const [ticket, setTicket] = useState(null);
  const [modal2, setModal2] = useState(false);
  const toggle2 = () => setModal2(!modal2);

  const [detail, setDetail] = useState({
    client: props.code,
    balance: 0,
    debt: 0,
    checks: 0,
    tickets: [],
    active: false,
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getDetail(props.code);
  }, [props.code, render]);

  const getDetail = async (code) => {
    setLoading(true);
    const response = await getClientDetail(code);
    setDetail(response.data);
    setLoading(false);
  };

  return (
    <>
      {loading && <Loader />}
      <Col lg={6} className="d-flex flex-column justify-content-center">
        <Card>
          <CardBody className="justify-content-center">
            <>
              <Row className="justify-content-center mb-2">
                <Col
                  sm={5}
                  className="d-flex justify-content-center font-size-16"
                >
                  <p>
                    <b>Estado del cliente {detail.client}</b>
                  </p>
                </Col>
                {detail.active === false && (
                  <Col sm={2}>
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => {
                        setTicket(null);
                        toggle2();
                      }}
                    >
                      Abono
                    </Button>
                  </Col>
                )}
              </Row>
              <Row>
                <Col sm={4} className="font-size-14">
                  <p>
                    Saldo: ${" "}
                    <b style={{ color: "green" }}>
                      {detail.balance.toLocaleString("es-CO")}
                    </b>
                  </p>
                </Col>
                <Col sm={4} className="font-size-14">
                  <p>
                    Deuda: ${" "}
                    <b style={{ color: "red" }}>
                      {detail.debt.toLocaleString("es-CO")}
                    </b>
                  </p>
                </Col>
                <Col sm={4} className="font-size-14">
                  <p>
                    Cheques pendientes:{" "}
                    <b style={{ color: "black" }}>{detail.checks}</b>
                  </p>
                </Col>
              </Row>
              <hr className="my-2" />
              {detail.tickets.length > 0 ? (
                <>
                  <Row className="justify-content-center mb-0">
                    <Col
                      sm={12}
                      className="d-flex justify-content-center font-size-16"
                    >
                      <p>
                        <b>Tickets pendientes de pago</b>
                      </p>
                    </Col>
                  </Row>
                  <div style={{ maxHeight: "20rem", overflowY: "auto" }}>
                    <Table
                      className="table table-borderless table-striped align-middle table-centered table-nowrap mb-3"
                      size="sm"
                      style={{
                        textAlign: "center",
                      }}
                    >
                      <thead>
                        <tr>
                          <th>Código</th>
                          <th>Total</th>
                          <th>Pagado</th>
                          <th>Fecha</th>
                          <th>Acción</th>
                        </tr>
                      </thead>
                      <tbody>
                        {detail.tickets.map((ticket, idx) => (
                          <tr key={idx}>
                            <th scope="row">{ticket.consecutive}</th>
                            <td>$ {ticket.total.toLocaleString("es-CO")}</td>
                            <td>
                              $ {ticket.value_paid.toLocaleString("es-CO")}
                            </td>
                            <td>{ticket.created_date}</td>
                            <td>
                              {ticket.pending_check ? (
                                "-"
                              ) : (
                                <Button
                                  color="primary"
                                  size="sm"
                                  onClick={() => {
                                    setTicket(ticket);
                                    toggle2();
                                  }}
                                >
                                  Pagar
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </>
              ) : (
                <p>El cliente no tiene tickets pendientes de pago.</p>
              )}
            </>
          </CardBody>
        </Card>
      </Col>
      {/* Modal */}
      {modal2 && (
        <PaymentModal
          isOpen={modal2}
          toggle={toggle2}
          ticket={ticket}
          client={detail.client}
          setRender={setRender}
          render={render}
        />
      )}
    </>
  );
};

export default ClientCard;
